import { useEffect, useState } from "react";

const AlertOpenFilter = (props) => {

    const [open, setOpen] = useState(false);
    const [closed, setClosed] = useState(false);
    const [active, setActive] = useState( () => {
        if (open === closed) {return false}
        else {return true}
    })

    useEffect( () => {
        // console.log("Refresh: ", refresh, "Checkout:", checkout) 

        if (open === closed) {
            props.updateFn("")
            setActive(false)
        }
        else {
            setActive(true)
            if (open) {props.updateFn(1)}
            if (closed) {props.updateFn(0)}
        }
    }, [open, closed])
 
    return (
        <div className="dropdown filter">
        <button className="btn btn-filter mx-1" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
            <i className={"fa-solid fa-filter" + (active ? " filter-active" : "")}></i>
        </button>
        <ul className="dropdown-menu p-2">
            <li className="">
                <input className="mx-1" type="checkbox" name="alert-filter-open" id="alert-filter-open-open" checked={open} onChange={(e) => setOpen(e.target.checked)}/>
                <label htmlFor="alert-filter-open-open">Open</label>
            </li>
            <li className="">
                <input className="mx-1" type="checkbox" name="task-filter-complete" id="alert-filter-open-closed" checked={closed} onChange={(e) => setClosed(e.target.checked)}/>
                <label htmlFor="alert-filter-open-closed">Closed</label>
            </li>
        </ul>
        </div>
    )
}

export default AlertOpenFilter;